<div class="px-4 py-24">
  <p class="text-xl">Page not found</p>
</div>
